// usage: {{jsonObj | pretty}}
export default function pretty(obj) {
  if (!obj) return obj;
  return JSON.stringify(obj, null, 2);
}
